import { useEffect, useRef } from 'react';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import MenuMovieEdit from './MenuMovieEdit';
import { Switch, Tooltip } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import systematic from '../../../config/systematic';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';
import antMessage from '../../../utils/extend/AntdNotification';

export default function MenuMovie(props: any) {

    const ref = useRef<any>(undefined);

    const { closeModal, isModel, menuWarehouseId } = props;
    const notificationApi = useNotificationInstance();

    /** api服务id */
    const apiId = 'menuMovie';

    /** 后端数据wmService */
    const wmService = systematic.wmService;

    useEffect(() => {
        //同步获取数据 async - await
        const fetchData = async () => {
        }
        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    //改变数据
    const handleChange = async (id: any, columnName: string, isValue: boolean) => {
        fetchApi.PUT(wmService, {
            apiId,
            apiVariable: id,
            apiExtend: "updateOne",
            apiData: {
                columnName,
                value: isValue
            }
        }).then(res => {
            if (res.success) {
                showCustomNotification(notificationApi!, {
                    type: 'success',
                    message: '编辑成功',
                    description: 'success',
                });
                initData();
            }
        }).catch(err => {
            antMessage('error', '删编辑失败', err.message);
        })
    };

    const initData = async () => {
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                menuWarehouseId
            }
        }
        ref.current.initData(currentData);
    }

    const showMovie = (movieId: any) => {
        const tencentEmbedUrl = 'https://v.qq.com/txp/iframe/player.html?vid=' + movieId;
        return (
            // eslint-disable-next-line jsx-a11y/iframe-has-title
            <iframe
                width="640"
                height="360"
                src={tencentEmbedUrl}
            // allowFullScreen
            />
        );
    }

    //表头
    const columnsHead = [
        {
            title: '菜式',
            dataIndex: 'foodName',
            render: (text: any, record: any) => {
                return (
                    <Tooltip placement="right" styles={{ root: { maxWidth: 'none' } }} title={showMovie(record.movieId)}>
                        <div>{record.menuWarehouse.foodName}</div>
                    </Tooltip>
                )
            }
        },
        {
            title: '标题',
            dataIndex: 'title',
        },
        {
            title: '视频ID',
            dataIndex: 'movieId',
        },
        {
            title: '简介',
            dataIndex: 'introduction',
            render: (text: any) => {
                return (
                    <Tooltip placement="topLeft" title={text}>{
                        (typeof text !== "undefined" && text !== null) ?
                            (text.length >= 20 ? text.substring(0, 20) + '......' : text)
                            : ''
                    }</Tooltip>
                )
            }
        },
        {
            title: '备注',
            dataIndex: 'memo',
            render: (text: any) => {
                return (
                    <Tooltip placement="topLeft" title={text}>{
                        (typeof text !== "undefined" && text !== null) ?
                            (text.length >= 20 ? text.substring(0, 20) + '......' : text)
                            : ''
                    }</Tooltip>
                )
            }
        },
        {
            title: '隐私查看',
            dataIndex: 'isPrivacy',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                    onChange={(e) => handleChange(record.id, 'isPrivacy', e)}
                />
            )
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '菜式视频',
        apiId,
        columns,
        showStates: true,
        showAdd: isModel ? true : false,
        pagination: true,
        EditComponent: MenuMovieEdit,
        extendIdName: "menuWarehouseId",
        sendPageData: { menuWarehouseId: menuWarehouseId }
    };

    return (
        <>
            {isModel ? <AntDraggableModal
                title={'菜式视频'}
                open={true}
                okText='关闭'
                // cancelText={stringHandle.isUndefined()}            
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={() => closeModal(true)}
                closable={false}
                maskClosable={false}
                width={900}>
                <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>
            </AntDraggableModal> : <WebUniversalNewEx ref={ref} props={extendProps}></WebUniversalNewEx>}
        </>
    )
}